import {
  ID_PLANT_CHANGED,
  ID_OBJECT_CHANGED,
  NODE_CHANGED,
  RESIZE_TREE,
  SET_DATA
} from './root-consts';

const initialState = {
  idPlant: null,
  idObject: null,
  modelCode: null,
  rights: {
    writableStructure: false,
    writableMedia: false,
    writableValue: false,
    writableDocument: false
  },
  pendingChanges: null,
  pendingChildChanges: null,
  pendingNodeUpdate: null,
  treeDividerX: -1,
  gridDividerX: -1,
  imagesDividerY: -1,
  hallmarks: [],
  treeNodes: [],
  comments: []
};

export default function(state, action) {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case RESIZE_TREE:
      return { ...state, treeDividerX: action.payload.treeDividerX };
    case ID_PLANT_CHANGED:
      return { ...state, idPlant: action.payload.idPlant, modelCode: action.payload.modelCode };
    case ID_OBJECT_CHANGED:
      return { ...state, idObject: action.payload.idObject };
    case NODE_CHANGED:
      return { ...state, idPlant: action.payload.idPlant, idObject: action.payload.idObject };
    case SET_DATA:
      return { ...state, hallmarks: action.payload.values, treeNodes: action.payload.nodes, comments: action.payload.comments  };
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** app/components/root/state/root-reducer.js
 **/